import { OnboardingChapter } from '../../../../../../pure-js/enums/OnboardingChapter'
import { isTutorialOnboardingStepCompleted } from '../../../../../../pure-js/libs/gameTutorialProgress'
import { GamerRoutes } from '../../../../config/routes/routeEnums'
export interface DontForgetTaskConfigItem {
  id: string
  titleKey: string
  descriptionKey: string
  actionKey: string
  route: string
}

// Always-required chapters. AiCoachGoals is deliberately absent: it is only mandatory when the user's
// organization has the One-on-One Coach enabled, so it must not gate this reminder for everyone else.
const REQUIRED_ONBOARDING_STEPS: OnboardingChapter[] = [
  OnboardingChapter.Introduction,
  OnboardingChapter.Demographics,
  OnboardingChapter.Assessment,
  OnboardingChapter.GameIntroduction,
  OnboardingChapter.Tutorial
]

export interface DontForgetUser {
  completedOnboardingSteps?: OnboardingChapter[]
  tutorialCompletedAt?: string
}

export interface DontForgetTaskConfigParams {
  user?: DontForgetUser | null
  showFeedbackTask?: boolean
}

// Only the game can say the tutorial was played out, so that one chapter is not read from the stored list.
const hasCompletedChapter = (user: DontForgetUser, chapter: OnboardingChapter): boolean => {
  if (chapter === OnboardingChapter.Tutorial) {
    return isTutorialOnboardingStepCompleted(user)
  }

  return (user.completedOnboardingSteps ?? []).includes(chapter)
}

const hasCompletedAllOnboardingSteps = (user?: DontForgetUser | null): boolean => {
  if (!user) {
    return false
  }

  return REQUIRED_ONBOARDING_STEPS.every((chapter) => hasCompletedChapter(user, chapter))
}

export const dontForgetTasksConfig = ({
  user,
  showFeedbackTask = true
}: DontForgetTaskConfigParams = {}): DontForgetTaskConfigItem[] => {
  const tasks: DontForgetTaskConfigItem[] = []

  if (!hasCompletedAllOnboardingSteps(user)) {
    tasks.push({
      id: 'dontForgetOnboarding',
      titleKey: 'gamer.dontForget.items.onboarding.title',
      descriptionKey: 'gamer.dontForget.items.onboarding.description',
      actionKey: 'gamer.dontForget.items.onboarding.action',
      route: GamerRoutes.ONBOARDING
    })
  }

  if (showFeedbackTask) {
    tasks.push({
      id: 'checkFeedback',
      titleKey: 'gamer.dontForget.items.feedback.title',
      descriptionKey: 'gamer.dontForget.items.feedback.description',
      actionKey: 'gamer.dontForget.items.feedback.action',
      route: GamerRoutes.LATEST_SESSION_FEEDBACK
    })
  }

  return tasks
}

export default dontForgetTasksConfig
